/** Parse free-text tool technical data into display rows. */

export type TechnicalDataRow = {
  label?: string;
  value: string;
};

/**
 * Accepts either "Label: value" lines or plain lines.
 * Blank lines are skipped.
 */
export function parseTechnicalData(text?: string | null): TechnicalDataRow[] {
  if (!text || !String(text).trim()) return [];
  return String(text)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const idx = line.search(/[:：]/);
      if (idx > 0 && idx < line.length - 1) {
        return {
          label: line.slice(0, idx).trim(),
          value: line.slice(idx + 1).trim(),
        };
      }
      return { value: line };
    });
}

export function technicalDataPreview(text?: string | null, maxLines = 3): string {
  const rows = parseTechnicalData(text);
  if (!rows.length) return '';
  return rows
    .slice(0, maxLines)
    .map((r) => (r.label ? `${r.label}: ${r.value}` : r.value))
    .join(' · ');
}
